import { Tooltip } from '@mui/material';
import React from 'react';
import { SingleMenuStepStatus } from './SingleMenuStepStatus';

export interface SingleMenuStepProps {
  id: string;
  stepName: string;
  stepDisplayName: string;
  stepStatus?: 'Incomplete' | 'Pending' | 'Approved' | 'Unavailable';
  toolTipText?: string;
  isSelected: boolean;
  onClick: () => void;
}

export const SingleMenuStep: React.FC<SingleMenuStepProps> = ({
  id,
  isSelected,
  stepDisplayName,
  stepStatus,
  toolTipText,
  onClick,
}) => {
  return (
    <div
      className={'bg-white border-b border-b-gray-100 px-[0.75rem] py-[0.75rem] border-l-[0.5rem]  border-l-red'.concat(
        isSelected ? ' border-l-red' : ' border-l-white',
      )}
    >
      <button onClick={() => onClick()} className={`flex me-[1.5rem]  w-full`} disabled={stepStatus === 'Unavailable'}>
        <div className="flex-col grow">
          <div className="flex flex-row justify-between">
            <div className="flex flex-row space-x-[0.625rem]">
              <p className="  text-gray-300">{id}.</p>
              <div className="space-y-[0.5rem]">
                <p
                  className={` content-center text-sm lg:block xl:block sm:hidden md:hidden  leading-4 my-[0rem] text-left ${
                    stepStatus === 'Unavailable' && 'text-gray-300'
                  }`}
                >
                  {stepDisplayName}
                </p>
                {stepStatus && <SingleMenuStepStatus status={stepStatus} />}
              </div>
            </div>
            {toolTipText && (
              <Tooltip title={toolTipText} arrow>
                <i className="icon-information_sel h-[1rem] w-[1rem]  xl:text-base lg:text-sm text-white bg-black rounded-full m-[0.25rem]"></i>
              </Tooltip>
            )}
          </div>
        </div>
      </button>
    </div>
  );
};
